// extracted by mini-css-extract-plugin
module.exports = {"FooterNavigation":"FooterNav_FooterNavigation__2-01X"};